<template>
    <v-card>
        <v-toolbar id="header-dialogue-inbox-full" class="h-auto" content-class="h-auto">
            <div class="d-flex align-items-center">
                <div style="margin:0 20px 0 0">
                    <v-btn @click="closeDialog()"
                           class="dgs-new-button" style="width: 40px; min-width: unset !important">
                        <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>
                </div>
            </div>
            <v-spacer></v-spacer>
            <div class="d-flex align-items-center toolbar-icons">
                <div class="custom-icon-wrapper">
                    <v-icon @click="closeDialog()">custom-icon mdi-close</v-icon>
                </div>
            </div>
        </v-toolbar>
        <div class="dialog-body h-100">
            <div class="row m-0 h-100">
                <div class="form-section col-md-4 col-lg-4 p-0 m-0 h-100">
                    <!--scrollable-white container-->
                    <div class=" scrollable-container h-100 main-bg-color">
                        <div class=" inner-single-component">
                            <div class="form-sub-section attachments-section" v-bind:class="{ 'view-mode': true }">
                                <div class="d-flex justify-content-between align-items-center">
                                    <h3 class="main-text-large">{{ $t("res_CardHeaders_Attachments") }}</h3>
                                    
                                </div>
                                <v-divider></v-divider>
                                <div >
	                                <v-list>
                                        <v-list-item class="text-hover-list" v-for="(item, i) in fileAttachments" :key="i" @click="displayAttachment(item)">
                                            <div class="d-flex justify-content-between align-items-center w-100">
                                                <div class="d-flex align-items-center overflow-hidden" style="gap:12px">
                                                    <v-icon class="attachment_icon p-0" v-if="item.extension === 'pdf'">mdi-file-pdf-box</v-icon>
                                                    <v-icon class="attachment_icon p-0" v-if="item.extension === 'doc' || item.extension === 'docx'">mdi-file-word</v-icon>
                                                    <v-icon class="attachment_icon p-0" v-if="item.extension !== 'doc' && item.extension !== 'docx' && item.extension !== 'pdf'">mdi-file</v-icon>
                                                
                                                    <v-list-item-content>
                                                        <v-list-item-title>
	                            							
	                            							<div  class="main-text-large overflow-hidden text-nowrap overflow-ellipsis">
                                                                {{ item.name }}
                                                            </div>
                                                        </v-list-item-title>
                                                          <v-list-item-subtitle>
                                                            
	                            							<span  class="action-label-new overflow-hidden text-nowrap overflow-ellipsis">
                                                                {{ $t("res_SubTitle_UploadedBy") + " " + item.createdBy }}
                                                            </span>  
                                                        </v-list-item-subtitle>
                                                        <v-list-item-subtitle>
                                                            
                                                            <span   class="action-label-new overflow-hidden text-nowrap overflow-ellipsis">
                                                                {{ $t("res_MenuItems_TaskProjectCreatedDate") + " : " + item.createdDate }}
                                                            </span>
                                                        </v-list-item-subtitle>
                                                        <v-list-item-subtitle>
                                                            <v-chip dark label small v-if="i==0">
                                                                {{ $t("res_Label_OriginalMail") }}
                                                            </v-chip>
                                                            <v-chip dark label small v-else>
                                                                {{ $t("res_Label_Attachment") }}
                                                            </v-chip>
                                                        </v-list-item-subtitle>
                                                        <v-list-item-subtitle>
                                                            <v-divider :thickness="10" v-if="i==0">

                                                            </v-divider> 

                                                        </v-list-item-subtitle>

                                                    </v-list-item-content>
                                                </div>
                                            </div>
                                        </v-list-item>
                                    </v-list>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div class="inner-single-component" >
                            <div class="form-sub-section notes-section">
                                <div class="d-flex justify-content-between align-items-center">
                                    <h3 class="main-text-large">{{ $t("res_Label_Transfers") }}</h3>
                                    <v-spacer></v-spacer>
                                    <div class="position-relative d-inline">
                                        <button class="view-all-btn d-flex align-items-center"  @click="exportTransfersToPdf()" v-tooltip="$t('res_Export_To_Pdf')">
                                            <v-icon class="light">mdi-file-pdf-box</v-icon>
                                        </button>
                                    </div>
                                </div>
                                <v-divider></v-divider>
                                <div v-bind:class="{ 'with-view-all': transfersFullList.length > defaultNumberOfTransferToDisplay }">
                                    <v-list>
                                        <v-list-item class="text-hover-list" v-for="(item, i) in transfers" :key="i">
                                            <v-list-item-content
                                                v-tooltip="item.instruction == '' ? '' : ($t('res_Label_Notes') + ' : ' + item.instruction)">
                                                <v-list-item-title>
                                                    <div class="text-wrap w-75">
                                                        <span><strong>{{ $t("res_Label_FromUser") }}: </strong>{{ item.fromUserFullName }} -
                                                            {{ item.fromStructureName }} ({{ item.fromCompanyName }})</span>
                                                    </div>
                                                    <div class="text-wrap w-75">
                                                        <span><strong>{{ $t("res_Label_ToUser") }}: </strong>{{ item.toUserFullName }} -
                                                            {{ item.toStructureName }} ({{ item.toCompanyName }})</span>
                                                    </div>
                                                    <div class="text-wrap w-75">
                                                        <span><strong>{{ $t("res_Label_ForwardDate") }}:
                                                            </strong>{{ utils.dateFormat(item.createdDate) }}</span>
                                                    </div>
                                                    <div class="text-wrap w-75">
                                                        <span><strong>{{ $t("res_Label_Action") }}: </strong>{{ item.purpose }}</span>
                                                    </div>
                                                </v-list-item-title>
                                            </v-list-item-content>
                                        </v-list-item>
                                    </v-list>
                                    <v-divider class="view-all-divider"
                                        v-if="transfersFullList.length > defaultNumberOfTransferToDisplay"></v-divider>
                                    <div class="view-all-wrapper d-flex justify-content-center align-content-center"
                                        v-if="transfersFullList.length > defaultNumberOfTransferToDisplay">
                                        <button class="view-all-btn d-flex align-items-center" @click="viewAllNotes()"
                                            v-if="numberOfTransferToDisplay != 1000">
                                            {{ $t("res_ButtonText_ViewAll") }} <v-icon class="light">mdi-chevron-down</v-icon>
                                        </button>
                                        <button class="view-all-btn d-flex align-items-center" @click="viewAllNotes()"
                                            v-if="numberOfTransferToDisplay == 1000">
                                            {{ $t("res_ButtonText_ShowLess") }} <v-icon class="light">mdi-chevron-up</v-icon>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="viewer-wrapper col-md-8 col-lg-8 h-100 p-0 m-0">
                    <!--viewer section-->
                    <div class="d-flex flex-column h-100">
                        <div class="p-0 scrollable-container flex-1 overflow-hidden">
                            <div v-if="empty_viewer" class="empty-viewer">
                                <img src="/assets/images/icons/no_preview.svg" />
                                <p class="mt-4 weight-400">{{ $t("res_Msgs_NoPreviewAvailable") }}</p>
                            </div>
                            <div v-if="!empty_viewer" id="viewer_template" class="h-100">
                                <iframe id="viewerFrame" :src="viewerFrame" class="h-100 w-100"></iframe>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </v-card>
</template>
<script>
    import axios from 'axios';
    import constants from '@/assets/js/constants';
    import * as utils from '@/assets/js/common.js';
    export default {
        name: 'OldArchivedDocumentView',
        components: {
        },
        props: {
            documentId: { type: Number, default: 0 },
            closeDialogEvent: { type: Function, default: function () { } },
            mimeType: { type: String, default: 0 }
        },
        data() {
            return {
                fileAttachments: [],
                rejected: false,
                transferSuccessMessage: '',
                transfers: [],
                transfersFullList: [],
                defaultNumberOfTransferToDisplay: 2,
                numberOfTransferToDisplay: 2,
                utils: utils,
                empty_viewer: true,
                viewerFrame: '',
            }
        },
        beforeMount() {
        },
        mounted() {
            this.viewerFrame = ''
            this.empty_viewer = true
            //this.setViewerUrl()
            this.getTransfers()
            this.getAttachments();
        },
        watch:
        {
            documentId(newVal, oldVal) {
                this.viewerFrame = ''
                if (oldVal != newVal && newVal > 0) {
                    this.getTransfers()
                    this.getAttachments()
                }
            }
        },
        methods: {
            getAttachments()
            {
                if (this.documentId == 0)
                    return
                
                this.fileAttachments = []
                
                window.showLoading()
                axios.get(constants.baseApiUrl + 'Integrations/GetAttachmentsByDocumentId?documentId=' + this.documentId, {headers: constants.headers})
                    .then(response => 
                    {
                        if (response.data != null)
                        {
                            //this.firstAttachment = false
                            this.fileAttachments = []
                            //this.fileAttachmentsFullList = []
                            response.data.forEach(element => 
                            {
                                this.fileAttachments.push(element)
                            });

                            if (this.fileAttachments.length != 0)
                                this.setViewerData(this.fileAttachments[0].id,this.fileAttachments[0].mimeType)
                            else
                                this.setViewerData(0,"")
                        }
                    })
                    .catch(error => alert(error))
                    .finally(() => window.hideLoading())
            },
            exportTransfersToPdf() {
                if (this.documentId == 0) return
                var extension = this.exportType == 1 ? '.xlsx' : '.pdf';
                axios({
                        url: constants.baseApiUrl + 'Integrations/GetTransfersListByDocumentId?documentId=' + this.documentId+'&extractToPdf=1',
                        method: 'GET',
                        responseType: 'blob',
                    })
                        .then((res) => {
                            var blob = new Blob([res.data], { type: "application/octetstream" });
                            const link = window.URL.createObjectURL(blob);
                            const a = document.createElement("a");
                            a.setAttribute("download", "ExportedData" + `${extension}`);
                            a.setAttribute("href", link);
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                        })
                        .catch((err) => window.hideLoading())
                        .finally(() => window.hideLoading())
            },
            viewAllNotes() {
                if (this.numberOfTransferToDisplay == 1000) {
                    this.numberOfTransferToDisplay = this.defaultNumberOfTransferToDisplay
                    this.transfers = this.transfersFullList.slice(0, this.defaultNumberOfTransferToDisplay)
                }
                else {
                    this.numberOfTransferToDisplay = 1000
                    this.transfers = this.transfersFullList
                }
            },
            getTransfers() {
                if (this.documentId == 0) return
                this.transfers = []
                this.transfersFullList = []
                this.numberOfTransferToDisplay = this.defaultNumberOfTransferToDisplay

                axios.get(constants.baseApiUrl + 'Integrations/GetTransfersListByDocumentId?documentId=' + this.documentId)
                    .then(response => {
                        response.data.forEach(element => {
                            var transferElement = {
                                fromUserFullName: element.fromUserFullName, toUserFullName: element.toUserFullName,
                                createdDate: element.createdDate, instruction: element.instruction, purpose: element.purpose,
                                toStructureName: element.toStructureName, fromStructureName: element.fromStructureName,
                                fromCompanyName: element.fromCompanyName, toCompanyName: element.toCompanyName
                            }
                            if (this.transfers.length < this.defaultNumberOfTransferToDisplay) {
                                this.transfers.push(transferElement)
                            }
                            this.transfersFullList.push(transferElement)
                        });
                    })
                    .catch(error => this.handleError(error))
            },
            displayAttachment(item)
            {
                this.setViewerData(item.id,item.mimeType)
                //var data = { docId:item.id, mimeType:item.mimeType }
            },
            setViewerData(id,mimeType){
                if(id> 0){
                axios.get(constants.baseApiUrl + 'Integrations/DownloadOpenTextDocuments?docId='+id+'&mimeType='+mimeType)
                    .then((res) => {
                        if(res.data!='')
                        {
                            this.empty_viewer = false
                            window.setViewerData(null,null,null,res.data);
                            this.viewerFrame = '/resources/viewer/viewer.html?lang=' + this.$i18n.locale + '&defaultScale=page-fit&pageMode=view' +
                                '&viewerMode=collapsed&r=' + new Date().getTime()
                        }
                    })
                    .catch((err) => console.log(err))
                    
                }
                else{
                    this.empty_viewer = true
                }
            },
            closeDialog(){
                this.closeDialogEvent('')
            }
        }
    }
</script>
